import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './global.css';
import { AuthProvider } from './context/AuthContext';
import { SnackbarProvider } from 'notistack';
import { BrowserRouter } from 'react-router';
import { UserProvider } from './context/UserContext';
import '@fontsource/poppins/200.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <UserProvider>
        <AuthProvider>
          <SnackbarProvider maxSnack={3}>
            <App />
          </SnackbarProvider>
        </AuthProvider>
      </UserProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
